// Shared constants for UI <-> backend keys.
import { LightningIcon, GraduationCapIcon, FireIcon, MicrophoneStageIcon, ChartBarIcon, CardsThreeIcon, MicrophoneIcon, ShareNetworkIcon, ClipboardTextIcon, SmileyIcon, NewspaperIcon } from "@phosphor-icons/react";

export const LEAGUES = ["ALL", "NBA", "NFL", "MLB", "UFC", "Soccer"];
export const ONBOARDING_LEAGUES = ["NBA", "NFL", "MLB", "UFC", "Soccer"];

export const CONTENT_STYLES = [
  { value: "casual_fan", label: "Casual Fan", desc: "Quick scores + simple explainers." },
  { value: "hardcore_analyst", label: "Hardcore Analyst", desc: "Advanced stats, tactics, film." },
  { value: "fantasy_player", label: "Fantasy Player", desc: "Stat lines, start/sit, waivers." },
  { value: "card_collector", label: "Card Collector", desc: "Rookies, parallels, market moves." },
  { value: "sports_creator", label: "Sports Creator", desc: "Scripts, captions, social-ready takes." },
  { value: "sports_reporter", label: "Sports Reporter", desc: "Broadcast-ready prep, interview questions, beat notes." },
];

export const LANGUAGES = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
  { value: "bilingual", label: "Bilingual" },
];

export const EMOTION_TAGS = [
  { value: "hype", label: "HYPE" },
  { value: "clutch", label: "CLUTCH" },
  { value: "heartbreak", label: "HEARTBREAK" },
  { value: "history", label: "HISTORY" },
  { value: "legend", label: "LEGEND" },
];

// 8 AI Modes (game-context)
export const GAMLY_PERSONALITIES = [
  { value: "broadcaster", label: "The Broadcaster", desc: "High-energy play-by-play hype.", icon: MicrophoneStageIcon },
  { value: "analyst", label: "The Analyst", desc: "Sharp film & data breakdowns.", icon: ChartBarIcon },
  { value: "coach", label: "The Coach", desc: "Strategy, adjustments, execution.", icon: ClipboardTextIcon },
  { value: "best_friend", label: "Best Friend", desc: "Casual, funny couch companion.", icon: SmileyIcon },
  { value: "trash_talker", label: "Trash Talker", desc: "Bold, brash, playful smack talk.", icon: FireIcon },
  { value: "press_box_reporter", label: "Press Box Reporter", desc: "Factual, broadcast-ready notes.", icon: NewspaperIcon },
];

// 8 AI Modes (game-context)
export const AI_MODES = [
  { key: "why_it_matters", label: "Why It Matters", desc: "The 30-second broadcaster explainer.", icon: LightningIcon },
  { key: "explain_like_im_new", label: "Explain Like I'm New", desc: "Plain-English primer for newcomers.", icon: GraduationCapIcon },
  { key: "hot_take", label: "Hot Take", desc: "Bold opinion in your group chat.", icon: FireIcon },
  { key: "spanish_recap", label: "Spanish Recap", desc: "Full Spanish summary, ESPN-deportes style.", icon: MicrophoneStageIcon },
  { key: "fantasy_impact", label: "Fantasy Impact", desc: "Start / sit / waiver — game-by-game.", icon: ChartBarIcon },
  { key: "card_market_impact", label: "Card Market", desc: "Rookies & parallels heating up.", icon: CardsThreeIcon },
  { key: "interview_questions", label: "Interview Qs", desc: "Sharp post-game questions.", icon: MicrophoneIcon },
  { key: "social_caption", label: "Social Caption", desc: "3 captions in your voice.", icon: ShareNetworkIcon },
];
